export default __webpack_public_path__ + "static/media/chevron_left.2e0bdd53.svg";